const ProposalInvestmentStatusEnum = Object.freeze({
    REJECTED: 'REJECTED',
    PENDING_ALLOTMENT: 'PENDING_ALLOTMENT',
    COMPLETED: 'COMPLETED'
});

export default ProposalInvestmentStatusEnum;
